var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "-0.70 -0.70 37 37",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.047 20.302l2.972 1.716c.34.195.497.6.38.975-.772 2.486-2.09 4.731-3.813 6.597-.266.287-.696.352-1.035.157l-2.97-1.716c-1.249 1.071-2.685 1.902-4.237 2.45v3.43c0 .392-.271.732-.654.818-2.437.547-5.055.576-7.616 0-.383-.086-.656-.425-.656-.817v-3.43c-1.551-.55-2.988-1.38-4.237-2.45l-2.97 1.715c-.339.195-.768.13-1.034-.157-1.724-1.866-3.042-4.111-3.814-6.597-.116-.374.041-.78.38-.975l2.973-1.716c-.299-1.618-.299-3.278 0-4.896l-2.972-1.715c-.34-.196-.497-.601-.381-.976.772-2.486 2.09-4.731 3.814-6.596.266-.288.695-.353 1.034-.158l2.97 1.716c1.25-1.071 2.686-1.902 4.237-2.45v-3.43c0-.392.272-.732.654-.818 2.438-.547 5.056-.575 7.617 0 .383.086.655.425.655.817v3.43c1.552.55 2.988 1.38 4.238 2.45l2.97-1.715c.338-.195.768-.13 1.034.158 1.723 1.865 3.042 4.11 3.814 6.596.116.374-.042.78-.381.975l-2.972 1.716c.298 1.618.298 3.278 0 4.896zm-7.587-2.448c0-3.076-2.503-5.58-5.579-5.58-3.076 0-5.579 2.504-5.579 5.58s2.503 5.58 5.58 5.58c3.075 0 5.578-2.504 5.578-5.58z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.49ba0e7ea206405e45e1c0ada3cceb86.svg";
export { ForwardRef as ReactComponent };